module.exports = __webpack_public_path__ + "static/img/b03.7b35111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b03.jpg
// module id = B8OI
// module chunks = 0